import React, { useContext } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { AuthState } from "../api/authApiClient";
import { AuthContext } from "../contexts/AuthProvider";
import { PageLoader } from "@/components/PageLoader";
import { ROUTES } from "@/routes/paths";

export const AuthRoute = () => {
  const { authState } = useContext(AuthContext);
  const location = useLocation();

  switch (authState) {
    case AuthState.TOKEN_EXPIRED:
    case AuthState.LOADING_TOKEN:
      return <PageLoader />;
    case AuthState.UNAUTHORIZED:
      return <Navigate to={`/${ROUTES.PUBLIC.LOGIN}`} />;
    case AuthState.PENDING_TWO_FACTOR:
      // Allow access to OTP verification page, redirect to login otherwise
      if (location.pathname.endsWith(ROUTES.PUBLIC.OTP_VERIFICATION)) {
        return <Outlet />;
      }
      return <Navigate to={`/${ROUTES.PUBLIC.LOGIN}`} />;
    case AuthState.AUTHORIZED:
      return <Outlet />;
    case AuthState.SESSION_TIMEOUT:
      // session cookie is invalid and we need a new csrf token
      window.location.reload();
      break;
    default:
      throw `Invalid authorization state: ${authState}`;
  }
};
